import { CalendarDays } from 'lucide-react';

import { InputSkeleton } from '@/_components';
import {
  CardContainer,
  Container,
  ContainerLayout,
  FormLayout,
  LeftSection,
  SectionHeading,
  StickyPageHeaderSkeletonWithButtons,
} from '@/_containers';

export default function Loading() {
  return (
    <ContainerLayout>
      <StickyPageHeaderSkeletonWithButtons numberOfButtons={2} withBreadcrumb />

      <Container>
        <LeftSection>
          {/* Basic Partner Info */}
          <CardContainer>
            <FormLayout>
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4 2xl:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4 2xl:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4 2xl:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4 2xl:col-span-4" />
              <div className="col-span-12 sm:col-span-6 lg:col-span-4 2xl:col-span-4" />
              <div className="col-span-12 sm:col-span-6 lg:col-span-4 2xl:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4 2xl:col-span-4" />
            </FormLayout>
          </CardContainer>

          {/* Termination Dates Section */}
          <CardContainer>
            <SectionHeading text="Termination & Notice Tracking" icon={CalendarDays} />
            <FormLayout className="mt-8">
              {/* Notice of Termination Date */}
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              {/* Required Notice Period */}
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              {/* Calculated Termination Date */}
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              {/* Override Termination Date */}
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              {/* Extension to Termination */}
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              {/* Final Termination Date */}
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />

              {/* Tail Compensation Enabled */}
              <InputSkeleton className="col-span-12" />
              {/* Tail Percentage (conditional) */}
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-3" />
              {/* Tail Duration */}
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-3" />
              {/* Tail Flat Payout */}
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-3" />
              {/* Tail Start Month */}
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-3" />

              {/* Transition Tail Enabled */}
              <InputSkeleton className="col-span-12" />
              {/* Transition Tail Percentage (conditional) */}
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              {/* Transition Tail Duration */}
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              {/* Transition Tail Start Month */}
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
            </FormLayout>
          </CardContainer>
        </LeftSection>
      </Container>
    </ContainerLayout>
  );
}
